
import { Union } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { union_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { defaultArg, some, value as value_2 } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { empty, mapIndexed, item, length, cons, tail, head, isEmpty, toArray, ofArray } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { FSharpChoice$2 } from "../fable_modules/fable-library-js.5.13.0/Choice.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.5.13.0/Result.js";
import { ofList, toList, ofArray as ofArray_1, toArray as toArray_1 } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { compare } from "../fable_modules/fable-library-js.5.13.0/Util.js";

/**
 * Static overloads of the composition function for lenses (>->).
 * These functions do not generally need to be called directly, but will
 * be used when calling Compose.optic.
 */
export class Compose_Lens extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["Lens"];
    }
    static Lens = new Compose_Lens();
}

export function Compose_Lens_$reflection() {
    return union_type("Optics.Compose.Lens", [], Compose_Lens, () => [[]]);
}

export function Compose_Lens_op_GreaterMinusGreater_Z15C92E89(_arg1, _arg) {
    return (_arg_1) => {
        const g1 = _arg_1[0];
        return [(a) => _arg[0](g1(a)), (c) => ((a_1) => _arg_1[1](_arg[1](c)(g1(a_1)))(a_1))];
    };
}

export function Compose_Lens_op_GreaterMinusGreater_Z335E5A0C(_arg3, _arg) {
    return (_arg_1) => {
        const g1 = _arg_1[0];
        return [(a) => _arg[0](g1(a)), (c) => ((a_1) => _arg_1[1](_arg[1](c)(g1(a_1)))(a_1))];
    };
}

export function Compose_Lens_op_GreaterMinusGreater_Z11B815C(_arg5, _arg) {
    return (_arg_1) => [(a) => _arg[0](_arg_1[0](a)), (c) => ((a_1) => _arg_1[1](_arg[1](c))(a_1))];
}

export function Compose_Lens_op_GreaterMinusGreater_Z4F046D59(_arg7, _arg) {
    return (_arg_1) => [(a) => _arg[0](_arg_1[0](a)), (c) => ((a_1) => _arg_1[1](_arg[1](c))(a_1))];
}

/**
 * Static overloads of the composition function for prisms (>?>).
 * These functions do not generally need to be called directly, but will
 * be used when calling Compose.optic.
 */
export class Compose_Prism extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["Prism"];
    }
    static Prism = new Compose_Prism();
}

export function Compose_Prism_$reflection() {
    return union_type("Optics.Compose.Prism", [], Compose_Prism, () => [[]]);
}

export function Compose_Prism_op_GreaterQmarkGreater_507FA136(_arg1, _arg) {
    return (_arg_1) => {
        const g1 = _arg_1[0];
        return [(a) => {
            const option = g1(a);
            return (option != null) ? some(_arg[0](value_2(option))) : undefined;
        }, (c) => ((a_1) => {
            let _arg_2;
            const mapping_1 = _arg[1](c);
            const option_1 = g1(a_1);
            _arg_2 = ((option_1 != null) ? some(mapping_1(value_2(option_1))) : undefined);
            return (_arg_2 != null) ? _arg_1[1](value_2(_arg_2))(a_1) : a_1;
        })];
    };
}

export function Compose_Prism_op_GreaterQmarkGreater_76E8D5B5(_arg3, _arg) {
    return (_arg_1) => {
        const g1 = _arg_1[0];
        return [(a) => {
            const option = g1(a);
            return (option != null) ? _arg[0](value_2(option)) : undefined;
        }, (c) => ((a_1) => {
            let _arg_2;
            const mapping = _arg[1](c);
            const option_1 = g1(a_1);
            _arg_2 = ((option_1 != null) ? some(mapping(value_2(option_1))) : undefined);
            return (_arg_2 != null) ? _arg_1[1](value_2(_arg_2))(a_1) : a_1;
        })];
    };
}

export function Compose_Prism_op_GreaterQmarkGreater_44AD0EE5(_arg5, _arg) {
    return (_arg_1) => [(a) => {
        const option = _arg_1[0](a);
        return (option != null) ? some(_arg[0](value_2(option))) : undefined;
    }, (c) => ((a_1) => _arg_1[1](_arg[1](c))(a_1))];
}

export function Compose_Prism_op_GreaterQmarkGreater_AB2E2E6(_arg7, _arg) {
    return (_arg_1) => [(a) => {
        const option = _arg_1[0](a);
        return (option != null) ? _arg[0](value_2(option)) : undefined;
    }, (c) => ((a_1) => _arg_1[1](_arg[1](c))(a_1))];
}

/**
 * Static overloads of the optic get function (^.). These functions do not generally
 * need to be called directly, but will be used when calling Optic.get.
 */
export class Optic_Get extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["Get"];
    }
    static Get = new Optic_Get();
}

export function Optic_Get_$reflection() {
    return union_type("Optics.Optic.Get", [], Optic_Get, () => [[]]);
}

export function Optic_Get_op_HatDot_Z146BA564(_arg1, _arg) {
    return (a) => _arg[0](a);
}

export function Optic_Get_op_HatDot_Z32FCD1E1(_arg3, _arg) {
    return (a) => _arg[0](a);
}

/**
 * Static overloads of the optic set function (^=). These functions do
 * not generally need to be called directly, but will be used when calling
 * Optic.set.
 */
export class Optic_Set extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["Set"];
    }
    static Set$ = new Optic_Set();
}

export function Optic_Set_$reflection() {
    return union_type("Optics.Optic.Set", [], Optic_Set, () => [[]]);
}

export function Optic_Set_op_HatEquals_Z147477F8(_arg1, _arg) {
    return (b) => _arg[1](b);
}

export function Optic_Set_op_HatEquals_Z32E30375(_arg3, _arg) {
    return (b) => _arg[1](b);
}

/**
 * Static overloads of the optic map function (%=). These functions do not generally
 * need to be called directly, but will be used when calling Optic.map.
 */
export class Optic_Map extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["Map"];
    }
    static Map$ = new Optic_Map();
}

export function Optic_Map_$reflection() {
    return union_type("Optics.Optic.Map", [], Optic_Map, () => [[]]);
}

export function Optic_Map_op_HatPercent_Z1462312A(_arg1, _arg) {
    return (f) => ((a) => _arg[1](f(_arg[0](a)))(a));
}

export function Optic_Map_op_HatPercent_Z32F545AB(_arg3, _arg) {
    return (f) => ((a) => {
        let _arg_1;
        const option = _arg[0](a);
        _arg_1 = ((option != null) ? some(f(value_2(option))) : undefined);
        return (_arg_1 != null) ? _arg[1](value_2(_arg_1))(a) : a;
    });
}

/**
 * Converts an isomorphism into a lens.
 */
export function Lens_ofIsomorphism(_arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    return [_arg[0], (b) => ((_arg_1) => _arg[1](b))];
}

/**
 * Converts an epimorphism into a prism.
 */
export function Prism_ofEpimorphism(_arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    return [_arg[0], (b) => ((_arg_1) => _arg[1](b))];
}

export function Optics_id_() {
    return [(x) => x, (x_1) => ((_arg) => x_1)];
}

/**
 * Isomorphism between a boxed and unboxed type.
 */
export function Optics_box_() {
    return [(value) => value, (value_1) => value_1];
}

/**
 * Lens to the first item of a tuple.
 */
export function Optics_fst_() {
    return [(tuple) => tuple[0], (a) => ((t) => [a, t[1]])];
}

/**
 * Lens to the second item of a tuple.
 */
export function Optics_snd_() {
    return [(tuple) => tuple[1], (b) => ((t) => [t[0], b])];
}

/**
 * Isomorphism to an list.
 */
export function Optics_Array_list_() {
    return [ofArray, toArray];
}

/**
 * Prism to Choice1Of2.
 */
export function Optics_Choice_choice1Of2_() {
    return [(x) => ((x.tag === 0) ? some(x.fields[0]) : undefined), (v_1) => ((x_1) => ((x_1.tag === 0) ? (new FSharpChoice$2(/* Choice1Of2 */ 0, [v_1])) : x_1))];
}

/**
 * Prism to Choice2Of2.
 */
export function Optics_Choice_choice2Of2_() {
    return [(x) => ((x.tag === 1) ? some(x.fields[0]) : undefined), (v_1) => ((x_1) => ((x_1.tag === 1) ? (new FSharpChoice$2(/* Choice2Of2 */ 1, [v_1])) : x_1))];
}

/**
 * Prism to Ok.
 */
export function Optics_Result_ok_() {
    return [(x) => ((x.tag === 0) ? some(x.fields[0]) : undefined), (v_1) => ((x_1) => ((x_1.tag === 0) ? (new FSharpResult$2(/* Ok */ 0, [v_1])) : x_1))];
}

/**
 * Prism to Error.
 */
export function Optics_Result_error_() {
    return [(x) => ((x.tag === 1) ? some(x.fields[0]) : undefined), (v_1) => ((x_1) => ((x_1.tag === 1) ? (new FSharpResult$2(/* Error */ 1, [v_1])) : x_1))];
}

/**
 * Prism to the head of a list.
 */
export function Optics_List_head_() {
    return [(_arg) => (!isEmpty(_arg) ? some(head(_arg)) : undefined), (v) => ((_arg_1) => (!isEmpty(_arg_1) ? cons(v, tail(_arg_1)) : _arg_1))];
}

/**
 * Prism to an indexed position in a list.
 */
export function Optics_List_pos_(i) {
    return [(_arg) => ((length(_arg) > i) ? some(item(i, _arg)) : undefined), (v) => ((l_2) => mapIndexed((i$0027, x) => ((i === i$0027) ? v : x), l_2))];
}

/**
 * Prism to the tail of a list.
 */
export function Optics_List_tail_() {
    return [(_arg) => (!isEmpty(_arg) ? tail(_arg) : undefined), (t_1) => ((_arg_1) => (isEmpty(_arg_1) ? empty() : cons(head(_arg_1), t_1)))];
}

/**
 * Isomorphism to an array.
 */
export function Optics_List_array_() {
    return [toArray, ofArray];
}

/**
 * Weak Isomorphism to an array of key-value pairs.
 */
export function Optics_Map_array_() {
    return [toArray_1, (elements) => ofArray_1(elements, {
        Compare: (x, y) => (compare(x, y) | 0),
    })];
}

/**
 * Weak Isomorphism to a list of key-value pairs.
 */
export function Optics_Map_list_() {
    return [toList, (elements) => ofList(elements, {
        Compare: (x, y) => (compare(x, y) | 0),
    })];
}

/**
 * Prism to the value in an Option.
 */
export function Optics_Option_value_() {
    return [(x) => x, (v) => ((_arg) => ((_arg == null) ? undefined : some(v)))];
}

/**
 * Lens to the value in an Option. using a default value if the option is None.
 */
export function Optics_Option_withDefault_(d) {
    return [(option) => defaultArg(option, d), (v$0027) => ((v) => some(v$0027))];
}

